module.exports = __webpack_public_path__ + "pattern4.88ab8ad95a8055d0f3dc.png";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/PROD-mufit-web/src/assets/images/pattern4.png
// module id = ../../../../../src/assets/images/pattern4.png
// module chunks = styles